(() => {
  if (window.Wishlist) return;

  const STORAGE_KEY = 'wishlist:v1';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const read = () => {
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  };

  const write = (items) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
    sync();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items } }));
  };

  const has = (handle) => read().includes(handle);

  const toggle = (handle) => {
    const items = read();
    const index = items.indexOf(handle);
    if (index === -1) items.unshift(handle);
    else items.splice(index, 1);
    write(items);
    return index === -1;
  };

  // Met à jour tous les coeurs + compteurs présents dans la page
  const sync = () => {
    const items = read();
    document.querySelectorAll('[data-wishlist-handle]').forEach((btn) => {
      const active = items.includes(btn.dataset.wishlistHandle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active);
    });
    const count = items.length ? String(items.length) : '';
    document.querySelectorAll('.wishlist-count').forEach((el) => {
      if (el.textContent !== count) el.textContent = count;
    });
  };

  // ---------- Encart de notification ----------
  // Textes et durée modifiables dans Paramètres du thème > Wishlist
  const config = window.wishlistSettings || {};
  const MESSAGES = {
    added: config.added || "L'article a été ajouté à votre liste de favoris.",
    removed: config.removed || "L'article a été supprimé de votre liste de favoris.",
  };
  const DURATION = (Number(config.duration) || 5) * 1000;
  let toast;
  let toastTimer;

  const showToast = (added) => {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'wishlist-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = `
      <svg class="wishlist-toast__icon" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <path d="M12 20.5s-7.5-4.6-9.6-9.2C.9 8 2.9 4 6.6 4c2.2 0 3.6 1.2 4.4 2.4h2c.8-1.2 2.2-2.4 4.4-2.4 3.7 0 5.7 4 4.2 7.3-2.1 4.6-9.6 9.2-9.6 9.2z"/>
      </svg>
      <p>${added ? MESSAGES.added : MESSAGES.removed}</p>`;
    toast.classList.toggle('wishlist-toast--removed', !added);

    clearTimeout(toastTimer);
    toast.classList.remove('is-visible');
    void toast.offsetWidth; // relance l'animation si on clique plusieurs fois
    toast.classList.add('is-visible');
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), DURATION);
  };

  // Délégation : fonctionne aussi après filtrage / pagination AJAX
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-wishlist-handle]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    const added = toggle(btn.dataset.wishlistHandle);
    showToast(added);

    // Sur la page wishlist, on retire la carte quand on dé-coeur
    if (!added) {
      const card = btn.closest('[data-wishlist-item]');
      if (card) {
        card.remove();
        renderEmptyState();
      }
    }
  });

  // Les filtres (facets.js) remplacent la grille : on resynchronise les nouveaux coeurs
  // (on ne réagit qu'à l'arrivée de nouveaux coeurs, et une seule fois par image)
  let syncQueued = false;
  new MutationObserver((mutations) => {
    if (syncQueued) return;
    const hasNewButtons = mutations.some((m) =>
      Array.from(m.addedNodes).some(
        (node) =>
          node.nodeType === 1 &&
          (node.matches('[data-wishlist-handle]') || node.querySelector('[data-wishlist-handle]'))
      )
    );
    if (!hasNewButtons) return;
    syncQueued = true;
    requestAnimationFrame(() => {
      syncQueued = false;
      sync();
    });
  }).observe(document.body, { childList: true, subtree: true });

  // Synchronise entre onglets
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) sync();
  });

  // ---------- Page wishlist ----------
  const renderEmptyState = () => {
    const page = document.querySelector('[data-wishlist-page]');
    if (!page) return;
    const grid = page.querySelector('.wishlist-page__grid');
    const empty = page.querySelector('.wishlist-page__empty');
    const isEmpty = !grid.querySelector('[data-wishlist-item]');
    grid.hidden = isEmpty;
    empty.hidden = !isEmpty;
  };

  const renderPage = async () => {
    const page = document.querySelector('[data-wishlist-page]');
    if (!page) return;
    const grid = page.querySelector('.wishlist-page__grid');
    const handles = read();

    // Chaque produit est rendu par Shopify avec le même snippet card-product que la collection
    const cards = await Promise.all(
      handles.map((handle) =>
        fetch(`${root}products/${encodeURIComponent(handle)}?section_id=wishlist-product-card`)
          .then((res) => (res.ok ? res.text() : null))
          .catch(() => null)
      )
    );

    const valid = [];
    grid.innerHTML = '';
    cards.forEach((html, i) => {
      if (!html) return; // produit supprimé ou dépublié
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const item = doc.querySelector('[data-wishlist-item]');
      if (!item) return;
      grid.appendChild(item);
      valid.push(handles[i]);
    });

    // Nettoie les produits qui n'existent plus
    if (valid.length !== handles.length) write(valid);

    sync();
    renderEmptyState();
  };

  window.Wishlist = { read, has, toggle, sync };

  const init = () => {
    sync();
    renderPage();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();